import { Box } from "@mui/material";
import { useState } from "react";
import { useSondertagContext } from "../context/sondertagContext";
import SondertagRankingDialog from "./SondertagRankingDialog";
import { useAppContext } from "../../../2_ksbHub/context/appContext";
import { LeaderboardIcon } from "../../../2_ksbHub/icons/icons";

export default function SondertagRankingButton() {
  const { teacherStats, isASondertageEventAdmin } = useSondertagContext();
  const { isMobile, isTeacherView } = useAppContext();

  const [open, setOpen] = useState(false);

  if (!isASondertageEventAdmin || isTeacherView) return null;

  const ranking = Object.entries(teacherStats || {})
    .map(([abbr, t]) => ({ abbr, ...t }))
    .sort((a, b) => a.ratio - b.ratio);

  return (
    <>
      <Box
        onClick={() => setOpen(true)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          px: 1.5,
          py: 0.5,
          opacity: 0.7,
          lineHeight: 0.4, // ✅ removes baseline weirdness
          borderRadius: 2,
          backgroundColor: "rgba(0,0,0,0.05)",
          cursor: "pointer",
        }}
      >
        <LeaderboardIcon fontSize="small" />
        {!isMobile ? "Ranking" : ""}
      </Box>

      <SondertagRankingDialog
        open={open}
        onClose={() => setOpen(false)}
        ranking={ranking}
      />
    </>
  );
}
